
$(function () {

    const modal = $('#imageModal');
    const modalInner = modal.find('.c_imageModal__inner');
    const modalImg = modal.find('.c_imageModal__inner img');
    const closeBtn = modal.find('.c_imageModal__close');

    function isSp() {
        return window.matchMedia('(max-width: 640px)').matches;
    }

    function resetModalLayout() {
        modalInner.removeAttr('style');
        modalImg.removeAttr('style');
        closeBtn.removeAttr('style');
    }

    function setModalLayout() {
        resetModalLayout();

        if (!isSp()) {
            return;
        }

        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const padding = 24;

        // 回転後の表示領域
        const maxRotatedWidth = vw - padding * 2;
        const maxRotatedHeight = vh - padding * 2;

        // 回転後は 9:16 として画面内に収める
        let rotatedWidth = maxRotatedWidth;
        let rotatedHeight = rotatedWidth * 16 / 9;

        if (rotatedHeight > maxRotatedHeight) {
            rotatedHeight = maxRotatedHeight;
            rotatedWidth = rotatedHeight * 9 / 16;
        }

        // 実際にrotateする前のfigureサイズ
        const innerWidth = rotatedHeight;
        const innerHeight = rotatedWidth;

        modalInner.css({
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: innerWidth + 'px',
            height: innerHeight + 'px',
            margin: 0,
            transform: 'translate(-50%, -50%) rotate(90deg)',
            transformOrigin: 'center center'
        });

        modalImg.css({
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        });

        requestAnimationFrame(function () {
            const rect = modalInner[0].getBoundingClientRect();

            closeBtn.css({
                position: 'fixed',
                top: (rect.top + 15) + 'px',
                left: (rect.right - 55) + 'px',
                right: 'auto',
                zIndex: 10
            });
        });
    }

    $('.js-image-modal').on('click', function () {
        const img = $(this).find('.p_worksSingle__floormap__image img');

        modalImg
            .attr('src', img.attr('src'))
            .attr('alt', img.attr('alt'));

        modal.addClass('is-open');

        requestAnimationFrame(setModalLayout);
    });

    $('.c_imageModal__overlay, .c_imageModal__close').on('click', function () {
        modal.removeClass('is-open');

        modalImg.attr({
            src: '',
            alt: ''
        });

        resetModalLayout();
    });

    $(window).on('resize orientationchange', function () {
        if (modal.hasClass('is-open')) {
            setTimeout(setModalLayout, 100);
        }
    });

});
